export default {
    validate(value) {
        return new RegExp("([0][2|3|4|5|6|7])[0-9]{7}").test(value);
    }
};